export const SIM_STATUSES = [
    "INVENTORY",
    "ASSIGNED",
    "ACTIVE",
    "SPARE",
    "LOST",
    "DEACTIVATED",
];

export function isHardwareSim(sim) {
    return (sim?.status || "").toUpperCase() !== "BUSINESS";
}

export const SIM_CARRIERS = ["ATT", "T-Mobile", "Verizon", "Sprint", "OTHER"];

export function simStatusStyle(status) {
    switch ((status || "").toUpperCase()) {
        case "ACTIVE":
            return "success";
        case "ASSIGNED":
            return "primary";
        case "INVENTORY":
            return "info";
        case "SPARE":
            return "default";
        case "LOST":
            return "danger";
        case "DEACTIVATED":
            return "warning";
        default:
            return "default";
    }
}

export function findUnitBySticker(units, input) {
    const key = String(input || "").trim().toLowerCase();
    if (key.length < 8) return {unit: null, matches: []};
    const prefix = key.slice(0, 8);
    const matches = (units || []).filter((unit) =>
        String(unit.unitId || "").toLowerCase().startsWith(prefix)
    );
    if (key.length > 8) {
        const exact = matches.filter((unit) => String(unit.unitId).toLowerCase() === key);
        if (exact.length === 1) return {unit: exact[0], matches: exact};
    }
    return {unit: matches.length === 1 ? matches[0] : null, matches};
}
